import { Link } from "react-router-dom";
import { CheckCircle2, ShieldCheck } from "lucide-react";
import PageShell from "@/components/brand/PageShell";

export default function PublicAffiliates() {
    return (
        <PageShell>
            <section className="max-w-3xl mx-auto px-6 py-16" data-testid="public-affiliates-page">
                <div className="tracking-caps text-[11px] font-semibold" style={{ color: "var(--st-royal)" }}>Affiliate program</div>
                <h1 className="font-serif text-4xl mt-2 leading-tight" style={{ color: "var(--st-navy)" }} data-testid="public-affiliates-title">
                    Earn a commission for referring serious students.
                </h1>
                <p className="mt-4 text-base leading-relaxed" style={{ color: "var(--st-ink-muted)" }}>
                    SwingTrust runs a lean affiliate program for people who genuinely believe in a slower,
                    structured approach to trading education. We are looking for referrers whose audience
                    would benefit from a 12-month curriculum, not signal-seekers looking for a quick flip.
                </p>

                <div className="mt-10 space-y-6">
                    <div className="st-surface p-6">
                        <div className="tracking-caps text-[11px] font-semibold" style={{ color: "var(--st-royal)" }}>How it works</div>
                        <ul className="mt-4 space-y-3 text-base">
                            {[
                                "Apply for an affiliate account. Approval is manual.",
                                "Get your unique referral link (?ref=<code>).",
                                "First-touch attribution: the first affiliate link a visitor clicks is credited.",
                                "You earn on every payment your referred student makes — monthly renewals, yearly enrollment, and monthly-to-yearly upgrades.",
                                "Refunds claw back the corresponding commission.",
                                "Payouts are manual for now — PayPal / Wise / bank transfer.",
                            ].map((line) => (
                                <li key={line} className="flex gap-3" style={{ color: "var(--st-ink)" }}>
                                    <CheckCircle2 size={16} color="var(--st-royal)" className="mt-1 flex-shrink-0" />
                                    <span>{line}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="rounded-lg p-6 flex items-start gap-4"
                         style={{ background: "var(--st-white)", border: "1px solid var(--st-navy)" }}>
                        <ShieldCheck size={22} strokeWidth={1.6} color="var(--st-navy)" className="flex-shrink-0 mt-0.5" />
                        <p className="text-sm leading-relaxed" style={{ color: "var(--st-ink)" }}>
                            <strong style={{ color: "var(--st-navy)" }}>We do not accept affiliate applications from signal groups, trade-copy services, or promoters using guarantee-language.</strong>
                            {" "}SwingTrust is an educational product. If your audience is drawn to hype, this partnership will not serve either of us.
                        </p>
                    </div>

                    <div className="text-center pt-4">
                        <Link to="/affiliate/signup" className="btn-royal inline-flex items-center justify-center" data-testid="public-affiliate-apply-cta">
                            Apply to become an affiliate
                        </Link>
                        <div className="mt-3 text-xs" style={{ color: "var(--st-silver-500)" }}>
                            Already an affiliate? <Link to="/login" className="link-royal">Sign in</Link>.
                        </div>
                    </div>
                </div>
            </section>
        </PageShell>
    );
}
